import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { environment } from '../config/environment';
import type { Wallet } from '../interfaces/metadata.interface';

const sha256Hex = async (message: string): Promise<string> => {
  const data = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

const getWallet = async (formId: string, walletId: string, workspaceId: string): Promise<{ wallet: Wallet }> => {
  const token = await sha256Hex(`${formId}.${walletId}.${workspaceId}`);
  const response = await axios.get(
    `${environment.API}/forms/${formId}/wallets/${walletId}`,
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      }
    }
  );
  return response.data;
};

export const useWallet = (formId: string, walletId: string, workspaceId: string) => {
  return useQuery({
    queryKey: ['wallet', formId, walletId, workspaceId],
    queryFn: () => getWallet(formId, walletId, workspaceId),
    enabled: !!formId && !!walletId && !!workspaceId,
  });
};


